const iconsTemplate: any = {
  "fa-home": "ios-home-outline",
  "fa-pencil-square": "ios-create-outline",
  "fa-credit-card-alt": "ios-card",
  "fa-tachometer": "ios-pie-outline",
  "fa-object-ungroup": "ios-open-outline",
  "fa-file-text": "ios-paper-outline",
  "fa-cogs": "ios-git-compare",
  "fa-question-circle": "ios-help-circle-outline",
  "fa-sign-out": "ios-log-out",
  "fa-cog": "ios-settings-outline",
  "fa-bar-chart": "ios-stats",
  "fa-bar-chart-o": "ios-stats",
  "fa-bell": "ios-notifications-outline",
  // DASH-31: Visualização Mobile. O react-ionicons 2.1.6 nao tem a variante
  // "-outline" deste icone; usar um nome inexistente renderiza um SVG vazio.
  "fa-mobile": "ios-phone-portrait"
};

export default (icon: string) => {
  if (icon != null && icon !== "") {
    const iconParsed = icon.trim().split(" ")[1];
    return iconsTemplate[iconParsed];
  }

  return null;
};
